'use client'
import { useState } from 'react'
import styled from 'styled-components'
import { PromoBanner } from '@shipt/design-system-banner'
import { useSearchParams } from 'next/navigation'
import { routes } from '@shared/constants/routes'
import { keyframes } from '@/features/shared/styles/effects'
import { GridLayoutContainer } from '@/features/shared/styles/layout'
import { getTargetCircleQueryParams } from '@/features/shared/components/Headers/Circle360Header/utils'
import { useFeatureFlags } from '@/features/shared/services/FeatureFlags/useFeatureFlags'

export const TargetCircle360PromoBanner = () => {
  const [isDismissed, setIsDismissed] = useState(false)
  const searchParams = useSearchParams()
  const params = getTargetCircleQueryParams(searchParams)
  const { flags, status } = useFeatureFlags()
  if (isDismissed || status === 'pending') return null

  return (
    <FixedPositionedGridLayout>
      <AnnouncementPromoBanner
        title={
          flags.c360_promo_copy
            ? 'Get $10 off your first order of $50+'
            : 'Get $10 off your first 2 orders of $75+'
        }
        actionButton={{
          content: 'Sign in',
          forwardedAs: 'a',
          href: `${routes.LOGIN.url}${params}`,
          isLink: true,
        }}
        onDismiss={() => {
          setIsDismissed(true)
        }}
        variant="brand"
        hasEmphasis
      />
    </FixedPositionedGridLayout>
  )
}

const FixedPositionedGridLayout = styled(GridLayoutContainer)`
  --content-max-width: 1440px;
  width: 100%;
  position: fixed;
  bottom: 16px;
  z-index: 9999;
  will-change: transform, opacity;
  transform: translateY(100%);
  opacity: 0;
  pointer-events: none;
  animation: ${keyframes.targetC360RevealBanner} 500ms ease-in-out 5s forwards;

  @media (prefers-reduced-motion: reduce) {
    transform: translateY(0);
    opacity: 1;
    pointer-events: auto;
    animation: none;
  }
`

const AnnouncementPromoBanner = styled(PromoBanner)`
  justify-self: end;
`
